import { apiClient } from '../api-client'
import type { DashboardData } from '@/types'

/**
 * Holt Dashboard Daten vom Backend (API v1)
 */
export async function getDashboard(): Promise<DashboardData> {
  const response = await apiClient.get<DashboardData>('/api/v1/dashboard')
  return response.data
}





